<template>
  <section class="no-entry-fence">
    <div class="layout system-setting-layout" style="margin-left: 0px;z-index: 11;">
      <div class="system-setting">
        <div class="layout-header regional-header" ref="searchBox" style="width: calc(100% - 33px);">
          <div class="infor-layout-header">
            <span class="title">禁行区绘制</span>
            <p>
              <el-button type="primary" size="small" @click="onAdd">添加禁行区</el-button>
            </p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'no-entry-fence',
  data(){
    return {}
  },
  methods: {
    // 事件处理区
    onAdd() {

    }
    // 数据处理
  }
}
</script>

<style lang="less">
.layout-header.regional-header {
  box-sizing: border-box;
  margin: 24px 16px;
  margin-top: 0;
}
.no-entry-fence{}
</style>
